export default {
  A: 'Ativo',
  F: 'Férias',
  B: 'Banco de Horas',
  O: 'Afastado',
  D: 'Demitido',
  I: 'Inativo',
};
